import { useEffect, useState } from "react";
import { INSTAGRAM, INSTAGRAM_URL } from "@/data/assets";
import { api, resolveImg } from "@/lib/api";
import { SectionTag } from "./Reveal";
import { Instagram, MoveUpRight } from "lucide-react";

export const Gallery = () => {
  const [images, setImages] = useState(null);

  useEffect(() => {
    api
      .listGallery()
      .then((res) => {
        const urls = (res.data || []).map((g) => resolveImg(g.image_url));
        setImages(urls.length ? urls : INSTAGRAM);
      })
      .catch(() => setImages(INSTAGRAM));
  }, []);

  const base = images || INSTAGRAM;
  const animate = base.length >= 4;
  // duplicate for a seamless marquee loop only when there's enough to scroll
  const row = animate ? [...base, ...base] : base;

  return (
    <section
      id="gallery"
      className="relative py-24 md:py-32 bg-[#0c0c0c] border-y border-white/10 overflow-hidden"
      data-testid="gallery-section"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 mb-12 flex flex-col md:flex-row md:items-end justify-between gap-6">
        <div>
          <SectionTag index="04" label="Recent Work" />
          <h2 className="font-display text-[clamp(2.4rem,6.5vw,5.5rem)] text-white">
            From the <span className="text-[#e31e24]">bench</span>.
          </h2>
        </div>
        <a
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noreferrer"
          className="btn-ghost self-start md:self-auto"
          data-testid="gallery-instagram-btn"
        >
          <Instagram size={17} /> @rayce_parts <MoveUpRight size={16} />
        </a>
      </div>

      <div
        className={
          animate
            ? "flex gap-4 md:gap-5 w-max px-5 animate-marquee-fast"
            : "flex gap-4 md:gap-5 flex-wrap justify-center px-5"
        }
      >
        {row.map((src, i) => (
          <a
            key={i}
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noreferrer"
            className="group relative block h-[260px] md:h-[340px] w-[220px] md:w-[300px] shrink-0 overflow-hidden bg-black border border-white/10"
            data-testid={`gallery-item-${i}`}
          >
            <img
              src={src}
              alt="Rayce Parts recent work"
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center">
              <Instagram
                size={30}
                className="text-white opacity-0 group-hover:opacity-100 transition-opacity"
              />
            </div>
          </a>
        ))}
      </div>
    </section>
  );
};
